<fc-column *ngFor="let c of columns; let i = index"  [column]="c" [stackNumber]="stackNumber" [index]="i"></fc-column>